import { twMerge } from 'tailwind-merge';

import { SheetContent } from '@/_components';
import type { RouteListItem } from '@/types';

import { SecondaryNavbar } from './navbar';

export function SecondaryMobileNavbar({
  setSidebarOpen,
  subNavLinks,
  isFullWidth,
}: {
  setSidebarOpen: () => void;
  subNavLinks: RouteListItem[];
  isFullWidth: boolean;
}) {
  return (
    <SheetContent
      overlayClassName="z-10"
      title="Secondary Menubar"
      aria-describedby=""
      className={twMerge('dark:bg-gray-850 z-10 w-28 bg-gray-50 px-0', isFullWidth ? 'md:left-56' : 'md:left-12')}
      closeButtonClassName="flex w-28 justify-center right-0 hover:bg-c-background dark:hover:bg-gray-900"
    >
      <SecondaryNavbar subNavLinks={subNavLinks} inDrawer callback={setSidebarOpen} />
    </SheetContent>
  );
}
